export default "__VITE_ASSET__DVaD3KxF__"